import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {HttpClientModule} from "@angular/common/http";
import {AttemptLoginComponent} from './attempt-login/attempt-login.component';
import {ConfigService} from "./config.service";
import { AttemptLogoutComponent } from './attempt-logout/attempt-logout.component';
import { NgxGlsSpinnerModule } from '@gls-group/ngx-gls-spinner';
import { DomStorageDisabledComponent } from './dom-storage-disabled/dom-storage-disabled.component';
import { DomStorageDisabledItemComponent } from './dom-storage-disabled/dom-storage-disabled-item/dom-storage-disabled-item.component';
import { GoogleAnalyticsService } from './google-analytics-service';
import { GlobalErrorHandler } from './core/globalErrorHandler';
import { HeaderComponent } from './header/header.component';
import { MessageBoxComponent } from './message-box/message-box.component';
import { ErrorPageComponent } from './error-page/error-page.component';

@NgModule({
  declarations: [
    AppComponent,
    AttemptLoginComponent,
    AttemptLogoutComponent,
    DomStorageDisabledComponent,
    DomStorageDisabledItemComponent,
    HeaderComponent,
    MessageBoxComponent,
    ErrorPageComponent
  ],
  imports: [
    NgxGlsSpinnerModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    CookieService,
    {provide: Window, useValue: window},
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfiguration,
      deps: [ConfigService, GoogleAnalyticsService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}


function initConfiguration (configService: ConfigService, googleAnalyticsService: GoogleAnalyticsService) {
  return function () {
    return configService.init().then(function() {
        const ga4TrackingId = String(configService.get('googleAnalytics4Code'));
        const tagManagerId = String(configService.get('googleTagManagerId'));
        if (ga4TrackingId && tagManagerId) {
          return googleAnalyticsService.initialize(ga4TrackingId, tagManagerId);
        }
        return Promise.resolve();
      }
    );
  }
}
